import { useFetchAndReset } from '@elentari/core/hooks/useFetchAndReset'
import {
  mapFragmentReplace,
  useReplaceFragments
} from '@elentari/core/hooks/useReplaceFragmets'
import { useAppBar } from '../../../hooks'
import { handleStateErrorsToRender } from '../../../utils/handleFetchStateError'
import { useCenario } from '../hooks/useCenario'
import { CenariosForm } from './CenariosForm'

export function CenariosMasterDetail() {
  const [cenarioState, cenarioActions] = useCenario()
  const [, appBarActions] = useAppBar()

  useReplaceFragments(appBarActions.replaceFragment, [
    mapFragmentReplace(
      cenarioState,
      c => c.entity.id,
      c => c.entity.descricao
    )
  ])
  useFetchAndReset(cenarioActions.fetch, cenarioActions.reset)

  return handleStateErrorsToRender(cenarioState, <CenariosForm />)
}
